export default {
    namespaced: true,
    state: {
		endpoint: 'organization',
		item: {},
        items: [],
        types: [],
    },
}